import { adminHttpClient } from '../../commons/adminHttpClient'
import OrderedPageFilter from '../../commons/orderedPageFilter'
import PagedList from '../../commons/PagedList'

import { ExpenseStatus } from 'domain/expenses/expenseStatus'
import { ExpenseAttachment } from '../expenses/expenseAttachment'

export interface PagedExpenses extends PagedList<Expense> {}

export interface Expense {
  id: string
  expenseNumber: number
  lastModifiedAt: string
  fullName: string
  companyName: string
  email: string
  status: ExpenseStatus
  amount: number
  attachments: ExpenseAttachment[]
}

const searchExpenses = (filter: OrderedPageFilter): Promise<any> => {
  filter = filter || {
    pageNumber: 1,
    pageSize: 10,
    orderColumn: 'createdAt',
    orderDescending: true,
  }
  return adminHttpClient.get('/DocReview/SearchExpense', filter)
}

export default searchExpenses
